import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { PageHeader }    from "@/components/shared/PageHeader";
import { GastoForm }     from "@/features/expenses";
import { useCreateGasto } from "@/features/expenses";
import type { ExpenseCreate } from "@cold-crew/shared";

export const Route = createFileRoute("/_app/gastos/nuevo")({
  component: NuevoGastoPage,
});

function NuevoGastoPage() {
  const navigate     = useNavigate();
  const createGasto  = useCreateGasto();

  async function handleSubmit(data: ExpenseCreate) {
    await createGasto.mutateAsync(data);
    navigate({ to: "/gastos" });
  }

  return (
    <div className="min-h-full bg-[#f4f1ea] px-4 py-5 sm:px-5 lg:px-6">\n      <div className="mx-auto max-w-3xl space-y-5">
      <PageHeader
        title="Nuevo gasto"
        description="Registra un gasto operativo de Cold Crew."
      />
      <div className="rounded-2xl border border-[#ded9cf] bg-white p-5 sm:p-6">
        <GastoForm
          onSubmit={handleSubmit}
          isLoading={createGasto.isPending}
          submitLabel="Registrar gasto"
        />
      </div>
      </div>
    </div>
  );
}
